import Vue from 'vue'
import {
    extend,
    ValidationObserver,
    ValidationProvider,
} from 'vee-validate'

import { required, email } from "vee-validate/dist/rules";
extend("required", required);

extend("email", email);


import { localize } from 'vee-validate';

import ru from 'vee-validate/dist/locale/ru.json';

// Install and Activate the Russian locale.
localize('ru', ru);

Vue.component('validation-provider', ValidationProvider)
Vue.component('validation-observer', ValidationObserver)
